import React from 'react';
import { FadeIn } from './FadeIn';
export function ClosingContrast() {
  return <section className="py-16 sm:py-24 px-4 bg-padel-dark" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <FadeIn data-id="element-38">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-39">
            Una última cosa antes de que decidas.
          </h2>
          <p className="text-xl text-center text-gray-300 mb-12" data-id="element-40">
            El próximo domingo vas a estar en alguno de estos dos lugares.
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mb-16" data-id="element-41">
          <FadeIn delay={0.1} data-id="element-42">
            <div className="bg-padel-surface border border-red-500/20 p-8 rounded-2xl h-full" data-id="element-43">
              <div className="text-red-400 font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-44">
                El primer lugar
              </div>
              <p className="text-gray-300 leading-relaxed" data-id="element-45">
                Son las 11 de la noche y estás buscando en YouTube qué hacer el
                lunes. Igual que el domingo pasado. Igual que el anterior. Con
                la misma carga mental. Con la misma sensación de que algo tiene
                que cambiar pero sin saber exactamente qué.
              </p>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} data-id="element-46">
            <div className="bg-padel-lime/5 border border-padel-lime/30 p-8 rounded-2xl h-full shadow-[0_0_30px_rgba(197,255,61,0.05)]" data-id="element-47">
              <div className="text-padel-lime font-bold mb-4 uppercase tracking-wider text-sm" data-id="element-48">
                El segundo lugar
              </div>
              <p className="text-white leading-relaxed font-medium" data-id="element-49">
                Son las 7 de la tarde y ya terminaste. La semana está
                planificada. Los anclajes están elegidos. Los tickets están
                impresos. La cabeza está libre. Y por primera vez en mucho
                tiempo, el domingo fue un día tuyo.
              </p>
            </div>
          </FadeIn>
        </div>

        <FadeIn delay={0.3} data-id="element-50">
          <div className="text-center" data-id="element-51">
            <p className="text-xl sm:text-2xl text-gray-300 mb-6" data-id="element-52">
              La diferencia entre esos dos domingos no es el talento. No es la
              experiencia. No es el esfuerzo.
            </p>
            <p className="text-4xl sm:text-6xl font-display font-black text-white uppercase tracking-tight" data-id="element-53">
              Es el sistema. <br data-id="element-54" />
              <span className="text-padel-lime" data-id="element-55">Y el sistema está acá.</span>
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}